import 'antd/lib/drawer/style'
import { Drawer } from './drawer'

import './drawer.less'
export * from 'antd/lib/drawer'

export default Drawer
